import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { ToastrService } from 'ngx-toastr';
import { EmptyStateComponent } from 'src/app/shared/components/common/empty-state/empty-state.component';
import { SkeletonDirective } from 'src/app/shared/directives/skeleton/skeleton.directive';
import { Alarm } from '../../models/alert.model';
import { AlertsApiService } from '../../services/alerts-api.service';

@Component({
  selector: 'app-alarms-panel',
  templateUrl: './alarms-panel.component.html',
  styleUrls: ['./alarms-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, EmptyStateComponent, MatTooltipModule, SkeletonDirective],
})
export class AlarmsPanelComponent implements OnInit {
  private readonly alertsApi = inject(AlertsApiService);
  private readonly toastr = inject(ToastrService);

  readonly alarms = signal<Alarm[]>([]);
  readonly isLoading = signal(true);
  readonly skeletonRows = [1, 2, 3, 4, 5];

  ngOnInit(): void {
    this.load();
  }

  syncCellTooltip(event: Event, tooltip: MatTooltip, force = false): void {
    const el = event.currentTarget as HTMLElement;
    const truncated = force || el.scrollWidth > el.clientWidth;
    tooltip.disabled = !truncated;
    if (truncated) tooltip.show();
  }

  private sortByDateDesc(alarms: Alarm[]): Alarm[] {
    return [...alarms].sort((left, right) => {
      return new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime();
    });
  }

  private load(): void {
    this.isLoading.set(true);
    this.alertsApi.listAlarms().subscribe({
      next: (alarms) => {
        this.alarms.set(this.sortByDateDesc(alarms ?? []));
        this.isLoading.set(false);
      },
      error: () => {
        this.alarms.set([]);
        this.isLoading.set(false);
        this.toastr.show('Não foi possível carregar o histórico.', 'Erro', { timeOut: 5000, messageClass: 'error' });
      },
    });
  }
}
